// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sfcEndNodeContainer[data-v-33726f5e] {\n  width: 90px;\n  height: 40px;\n  border-radius: 30px;\n  -webkit-box-shadow: 0 1px 5px 0 rgba(10, 30, 65, 0.08);\n          box-shadow: 0 1px 5px 0 rgba(10, 30, 65, 0.08);\n  color: #fff;\n  line-height: 40px;\n  text-align: center;\n  background: #6e6e6e;\n}\n", ""]);
// Exports
module.exports = exports;
